import { FETCH_SCHEDULES, FETCH_SCHEDULES_DONE, FETCH_SCHEDULES_ERR, EDIT_SCHEDULES, EDIT_SCHEDULES_DONE, EDIT_SCHEDULES_ERR } from './actionTypes';
const initialState = {
    data: [],
    pendingChanges: false,
    isLoading: false,
    isUpdated: false,
    error: false,
    errorMessage: null
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SCHEDULES:
            return Object.assign(Object.assign({}, state), { data: [], pendingChanges: false, isLoading: true, isUpdated: false, error: false, errorMessage: null });
        case FETCH_SCHEDULES_DONE:
            return Object.assign(Object.assign({}, state), { data: action.data.schedules, pendingChanges: action.data.pending_changes, isLoading: false, isUpdated: false, error: false, errorMessage: null });
        case FETCH_SCHEDULES_ERR:
            return Object.assign(Object.assign({}, state), { data: [], pendingChanges: false, isLoading: false, isUpdated: false, error: true, errorMessage: action.errorMessage });
        case EDIT_SCHEDULES:
            return Object.assign(Object.assign({}, state), { isLoading: true, isUpdated: false, error: false, errorMessage: null });
        case EDIT_SCHEDULES_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), action.data), { isLoading: false, isUpdated: true, error: false, errorMessage: null, isAutoApplied: action.data.isAutoApplied });
        case EDIT_SCHEDULES_ERR:
            return Object.assign(Object.assign({}, state), { isLoading: false, isUpdated: false, error: true, errorMessage: action.errorMessage });
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map